import eventBus from "@/common/bus";
import { ColorModifiers } from "buefy/types/helpers";
import { TicketStatus, SortBy, SortOrder, CurrencyCode } from "./enum";

export default class Shared {
  public static messages = {
    SESSION_EXPIRED: "Session expired, please login again!",
    SERVICE_UNAVAILABLE: "Service currently unavailable, Please try again",
    SOMETHING_WRONG: "Something went wrong, Please try again after some time",
    GOOGLE_AUTH_ERROR: "Error on Google authentication",
    ACCESS_TOKEN_ERROR: "Error on getting access token",
    BASIC_COMPANY_SAVE_ERROR: "Unable to save company details",
    COMPANY_CONFLICT: "Company name or website already exist",
    USER_CONFLICT: "User with same email already exist",
    USER_NOT_FOUND: "User not found",
    CONFIGURE_ZENDESK_USER: "User successfully configured with Zendesk",
    DEPARTMENT_CONFLICT: "Department with the same name already exist",
    DEPARTMENT_DELETE_CONFLICT: "Could not delete department as user is assigned to this department",
    INVALID_INVITATION: "Invitation link is invalid, Please refer valid invitation!",
    USER_INVITE_SUCCESSFUL: "The invitation has been successfully sent to the user",
    TICKET_NOT_FOUND: "Ticket not found",
    TICKET_ACCESS_DENIED: "You are not allowed to view this ticket",
    TICKET_UPDATED: "Ticket has been updated",
    TICKET_CREATED: "Ticket has been created",
    TWILIO_SETTINGS_SAVE_SUCCESSFUL: "Company twilio settings saved successfully",
    INTEGRATION_VERIFICATION: "Integration verification successful",
    INTEGRATION_DISABLE: "Integration has been disabled successfully",
    INVOICE_NOT_FOUND: "Invoice not found",
    TASK_NOT_FOUND: "Task not found",
  };
  public static localStorageKeys = {
    API_BEARER_TOKEN: "as.api.token",
    USER_EMAIL: "as.user.email",
    INVITATION_ID: "as.user.invite",
    INTEGRATION_ID: "as.user.integrate",
    RECENT_TICKETS: "as.tickets.recent",
    IS_SIGN_UP: "as.tickets.signup",
    REDUCE: "as.navigation.reduce",
  };
  public static dateFormat = "DD-MM-YYYY";
  public static dateTimeFormat = "DD-MM-YYYY hh:mm:ss A";

  public static conflict = "Conflict";
  public static notFound = "NotFound";
  public static noTwilioSetup = "NoTwilioSetup";
  public static unAuthorize = "Unauthorized";

  public static defaultPageSize = 10;
  public static defaultSortBy = SortBy.CreatedAt;
  public static defaultSortOrder = SortOrder.Desc;
  public static defaultCountryCode = "+44";
  public static defaultCurrency = CurrencyCode.GBP;

  public static showToastMessage(msg: string, color: ColorModifiers) {
    eventBus.$emit("toastHandler", msg, color);
  }

  public static setSignUp(flag: boolean) {
    localStorage.setItem(this.localStorageKeys.IS_SIGN_UP, flag ? "1" : "0");
  }

  public static getStatusColor(status: TicketStatus): string {
    switch (status) {
      case TicketStatus.New:
        return "is-warning";
      case TicketStatus.Open:
        return "is-danger";
      case TicketStatus.Pending:
        return "is-info";
      case TicketStatus.Solved:
        return "is-grey";
      case TicketStatus.Closed:
        return "is-success";
      case TicketStatus.Hold:
        return "is-warning";
      case TicketStatus.Deleted:
        return "is-danger";
      default:
        return "is-primary";
    }
  }
}
